import axios from 'axios'
import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { profileUpdateType2 } from 'Pages/Frontend/Interface/EmployeeManager/Profile/Profile'
import { ProfileUpdateType } from 'Models'

AxiosInterceptor()

const profileService = {
  profile: async () => {
    return await axios.get('/employee/profile')
  },

  getProfile: async (employeeId: string | undefined) => {
    return await axios.get(`/admin/employee/${employeeId}`)
  },
  getAllProfile: async (pageNumber: string) => {
    return await axios.get(`/admin/employee?pageNumber=${pageNumber}`)
  },
  adminUpdateUserProfile: async (employeeId: string | undefined, data: ProfileUpdateType) => {
    return await axios.put(`/admin/employee/${employeeId}`, data)
  },
  updateProfile: async (data: ProfileUpdateType) => {
    return await axios.post('/employee/profile', data)
  },
  updateProfileV2: async (data: ProfileUpdateType) => {
    return await axios.patch('/employee/profile', data)
  },

  updateProfile2: async (data: profileUpdateType2) => {
    return await axios.post('/employee/profile', data)
  },
}

export default profileService
